export const getUserRoles = (user) => {
    return (user === null || user === void 0 ? void 0 : user.roles) || new Array();
};
export const isOrderer = (user) => {
    return getUserRoles(user).some(r => r.role === 'Orderer');
};
